import '../../utils/index.mjs';
import _sfc_main from './src/form2.mjs';
import _sfc_main$1 from './src/form-item2.mjs';
export { formEmits, formProps } from './src/form.mjs';
export { formItemProps, formItemValidateStates } from './src/form-item.mjs';
import './src/types.mjs';
import { withInstall, withNoopInstall } from '../../utils/vue/install.mjs';

const ElForm = withInstall(_sfc_main, {
  FormItem: _sfc_main$1
});
const ElFormItem = withNoopInstall(_sfc_main$1);

export { ElForm, ElFormItem, ElForm as default };
//# sourceMappingURL=index.mjs.map
